import { addMethod, string } from 'yup';

const EMPTY_STRING_CONST = 'EMPTYSTR';

addMethod(string, 'stringify', function(value) {
  if (value === '') {
    return EMPTY_STRING_CONST;
  }
  return value !== undefined ? `${value}` : '';
});
addMethod(string, 'parse', function(stringValue) {
  if (stringValue === EMPTY_STRING_CONST) {
    return '';
  }
  return stringValue && typeof stringValue === 'string'
    ? this.isType(null) && stringValue === 'null'
      ? null
      : stringValue
    : undefined;
});

export default string;
